import { render, staticRenderFns } from "./pricehelp.vue?vue&type=template&id=6e0c740e&"
import script from "./pricehelp.vue?vue&type=script&lang=js&"
export * from "./pricehelp.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../var/task/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/task/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('6e0c740e')) {
      api.createRecord('6e0c740e', component.options)
    } else {
      api.reload('6e0c740e', component.options)
    }
    module.hot.accept("./pricehelp.vue?vue&type=template&id=6e0c740e&", function () {
      api.rerender('6e0c740e', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "tmp/tmp-2Zpk3kgy1cvL6/JS/pricehelp.vue"
export default component.exports